import { render, staticRenderFns } from "./PresidiPrestazioniEditPage.vue?vue&type=template&id=61e3b09e"
import script from "./PresidiPrestazioniEditPage.vue?vue&type=script&lang=js"
export * from "./PresidiPrestazioniEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports